import { render, staticRenderFns } from "./MyWayInner.vue?vue&type=template&id=ad72fe3a&"
import script from "./MyWayInner.vue?vue&type=script&lang=js&"
export * from "./MyWayInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports